import React from 'react';
import { StyleSheet, View, Image } from 'react-native';
import { Button, Theme, ButtonTypes, LeaderboardStatsScreen} from 'fitbeat.react-native-components';
import { GridLayoutWithRightContent } from './Layouts/GridLayoutWithRightContent';

export const LeaderboardStatsContainer = (props) => (
  <GridLayoutWithRightContent {...props}>
    <View className='full-height' style={{ flex: 1 }}>
      <View style={styles.container}>
        <Image
          style={{ resizeMode: 'contain', width: 15, height: 15, tintColor: Theme.PRIMARY }}
          source={require('../../assets/keyboard-left-arrow-button.png')}
        />
        <Button
          onPress={() => props.navigation.navigate('TrackingDashboard')}
          isLoading={false}
          fontColor={Theme.PRIMARY}
          buttonType={ButtonTypes.OUTLINE}
          containerStyle={styles.buttonContainer}
          title='Back'
        />
      </View>
      <LeaderboardStatsScreen {...props} />
    </View>
  </GridLayoutWithRightContent>
);

const styles = StyleSheet.create({
  container: {
    width: '20%',
    marginBottom: 5,
    marginTop: 5,
    flexDirection: 'row',
  },
  buttonContainer: {
    border: 'none',
    marginTop: -13,
    marginLeft: 5,
  },
});
